export default __webpack_public_path__ + "images/NU.13c76f7.png";